export const dashboard = {
      title: 'Inventory dashboard',
      subtitle: 'Track stock, alerts, and movements in real time',
      newMovement: 'New movement',
      lowStock: 'Low stock products',
      recentMovements: 'Recent movements',
      preferredUnitSwitch: 'Unit',
      preferredUnitSwitchHint: 'View in preferred unit.',
      availableBoxes: 'Available boxes',
      productsBelowMinimum: 'Products below minimum',
      movementsToday: 'Movements today',
      boxesSoldThisWeek: 'Boxes sold this week',
      inventoryCoverage: 'Inventory coverage',
      inventoryTurnover: 'Inventory turnover',
      totalInventoryBoxes: 'Total pieces',
      inventoryValue: 'Inventory value',
      last7Days: 'Last 7 days',
      healthy: 'Healthy',
      averageCostPerBox: 'Avg cost/box',
      weeks: 'weeks',
      turnover4Weeks: '4-week turnover',
    } as const;
